module.exports = __webpack_public_path__ + "img/capacity_bg.d3fd2ceb.svg";